<template>
	<div class="progress-box">
		<div class="progress">
			<div class="progress-bar" :class="[setType,striped&&'progress-bar-striped',animate&&'active']" :style="{width:state+'%'}">
				<span v-if="!end">{{state+"%"}}</span>
			</div>
		</div>
		<span class="info" v-if="!!end">{{state+"%"}}</span>
	</div>
</template>

<script>
	export default {
		props: {
			state: {
				type: Number,
				default: 0
			},
			max: Number,
			type: String,
			end: Boolean,
			striped: Boolean,
			animate: Boolean
		},
		computed: {
			setProgress() {

			},
			setType() {
				return this.type ? "progress-bar-" + this.type : ""
			}
		}
	}
</script>
<style lang="less">
	@import (reference) "../../assets/lib/css.less";
	.progress {
		.unbdr;
		height: 5px;
		overflow: inherit;
		position: relative;
		.mgr(6*@mpb);
		.mgb(0);
		.progress-bar {
			height: 5px;
			.tar;
			.pdr;
		}
		&-box {
			position: relative;
			.mgb;
			.pd(8px 0);
			.info {
				position: absolute;
				right: 50px;
				top: 0;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// progress.vue?9c421eb6